// extracted by mini-css-extract-plugin
module.exports = {"bookContainer":"BookContainer_bookContainer__3iigm"};